import React from 'react';
import { BookOpen, Brain, Shield } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">About the Audiobook</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="about-content">
          <div className="about-main">
            <p className="body-large">
              This audiobook explores the psychological impact of modern conflict—particularly the constant exposure to misinformation, emotional manipulation, and cognitive overload.
            </p>
            
            <p className="body-medium">
              Rather than promoting fear, the book empowers listeners with awareness, strategies, and tools to maintain emotional stability and build long-term mental resilience in an increasingly complex information environment.
            </p>
          </div>
          
          <div className="about-grid">
            <div className="about-card">
              <div className="card-icon">
                <Brain size={40} />
              </div>
              <h3 className="heading-5">Awareness of Modern Techniques</h3>
              <p className="body-small">
                Understanding psychological warfare techniques used in today's hybrid conflict environment.
              </p>
            </div>
            
            <div className="about-card">
              <div className="card-icon">
                <Shield size={40} />
              </div>
              <h3 className="heading-5">Emotional Stability</h3>
              <p className="body-small">
                Practical strategies for maintaining mental clarity and emotional balance.
              </p>
            </div>
            
            <div className="about-card">
              <div className="card-icon">
                <BookOpen size={40} />
              </div>
              <h3 className="heading-5">Mental Resilience Tools</h3>
              <p className="body-small">
                Actionable techniques for building long-term psychological strength.
              </p>
            </div>
          </div>
          
          <div className="about-callout">
            <p className="body-large">
              At its core, this work is a call to action: <strong>protecting mental health is no longer passive—it requires informed, intentional effort.</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
